/** Default page size for Industry News list pagination. */
export const INDUSTRY_NEWS_PAGE_SIZE = 25;

/** Max articles retained per feed to avoid one noisy feed dominating the list. */
export const RSS_MAX_ITEMS_PER_FEED = 10;

/** Upper bound on merged RSS articles across all selected feeds. */
export const RSS_MAX_TOTAL_ARTICLES = 750;

/** RSS proxy pool tuning — modest concurrency with inter-chunk pacing. */
export const RSS_PROXY_MAX_CONCURRENT = 7;
export const RSS_PROXY_CHUNK_SIZE = 8;
export const RSS_PROXY_INTER_CHUNK_MS = 300;

export function getIndustryNewsTotalPages(
  itemCount: number,
  pageSize: number = INDUSTRY_NEWS_PAGE_SIZE
): number {
  return Math.max(1, Math.ceil(itemCount / pageSize));
}

export function sliceIndustryNewsPage<T>(
  items: T[],
  page: number,
  pageSize: number = INDUSTRY_NEWS_PAGE_SIZE
): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}
